(function() {
  /* eslint-disable */
  document.getElementById('uploadContactCV').addEventListener('click', function () {
    document.getElementById('uploadContactCVInput').click();
  });

  document.getElementById('uploadContactCVInput').addEventListener('change', function (event) {
    var file = event.target.value;
    var fileName = file.split('\\');
    document.getElementById('uploadContactCV').innerHTML = fileName[fileName.length - 1];
    event.preventDefault();
  });

  const cvField = document.querySelector('[for="curriculum"]').parentElement;
  document.getElementById('iWantToBeTeacher').addEventListener('change', function(event) {
    if (event.target.checked) {
      cvField.style.display = 'block';
    }
    else {
      cvField.style.display = 'none';
    }
  });

})();
